export const configFileName = 'config.json'
